<template>
  <div v-if="src">
    <top-bar @reload="reloadEmpresa()"/>
    <div class="content text-center" style="padding-top: 10vh" v-if="load">
      <loading/>
    </div>
    <div v-else>
      <web-frame :src="src" :auth="key"/>
    </div>
  </div>
</template>
<script>
  import WebFrame from "@/views/gestor/WebFrame";
  import TopBar from "@/components/commons/TopBar";
  import Loading from "@/components/commons/Loading";
  export default {
    components: {Loading, TopBar, WebFrame},
    data() {
      return {
        src: null,
        load: false,
        key: localStorage.getItem('key'),
        ifood: false
      }
    },

    methods: {
      reloadEmpresa() {
        this.load = true;
        this.$nextTick(() => {
          setTimeout(() => {
            this.load = false;
            this.iniciar();
          }, 1000);
        });
      },

      iniciar() {
        const host = window.location.hostname;
        let src = "https://portal.lecard.app/";

        if (localStorage.getItem('base_server') === this.server_teste || host.startsWith('hhh')) {
          src = "https://hhh.portal.lecard.delivery/";

        } else if (host.startsWith('beta')) {
          src = "https://beta.portal.lecard.delivery/";

        } else if (host.startsWith('localhost')) {
          src = "https://hhh.portal.lecard.delivery/";
          //src = "http://localhost:8081/";
        }

        this.src = src;
      }
    },

    mounted() {
      this.iniciar();
      this.ifood = !!this.$store.state.chatIfood;

      if (this.ifood) {
        this.$store.state.chatIfood = false;
      }
    },

    watch: {
      $route() {
        this.iniciar();
      }
    },

    beforeDestroy() {
      if (this.ifood) {
        this.$store.state.chatIfood = true;
      }
    }
  }
</script>
<style>
</style>
